import * as Types from '@/types/productivity-schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql-productivity';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type P_SwitchWorkspaceMutationVariables = Types.Exact<{
  personId: Types.Scalars['ID']['input'];
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type P_SwitchWorkspaceMutation = { switchWorkspace: { id: string, entityId?: string | null } };


export const P_SwitchWorkspaceDocument = /*#__PURE__*/ gql`
    mutation p_SwitchWorkspace($personId: ID!, $workspaceId: ID!) {
  switchWorkspace(personId: $personId, workspaceId: $workspaceId) {
    id
    entityId
  }
}
    `;

export function useP_SwitchWorkspaceMutation() {
  return Urql.useMutation<P_SwitchWorkspaceMutation, P_SwitchWorkspaceMutationVariables>(P_SwitchWorkspaceDocument);
};